import { Action } from '@ngrx/store';
import { IShipmentLocationResponse } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-response';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import {
  IAddressResponse,
  IRequestedAddressResponse,
} from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { IPointOfDeliverySalesArea } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-area';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { FormattedAddress } from '@ordersnproducts/modules/shared/models/FormattedAddress.interface';
import { PointOfDeliveryPayload } from '../../components/point-of-delivery/new-pod-creation-modal/new-pod-creation-modal.component';
import { PointOfDeliveryRequest } from '@cemex-core/cmx-api/models/point-of-delivery/point-of-delivery-req';

export const LOAD_INITIAL_STATE = '[Point of delivery] Load initial state';
export const LOAD = '[Point of delivery] Load';
export const LOAD_COMPLETE = '[Point of delivery] Load Complete';
export const LOAD_FAIL = '[Point of delivery] Load Fail';
export const REMOVE_SELECTED_POD = '[Point of delivery] Remove Selected';
export const POINT_OF_DELIVERY_SET = '[Point of delivery] Set';
export const LOAD_ADDRESS = '[Point of delivery] Load address';
export const LOAD_ADDRESS_SUCCESS = '[Point of delivery] Load address success';
export const LOAD_ADDRESS_FAIL = '[Point of delivery] Load address fail';
export const LOAD_SALES_AREA = '[Point of delivery] Load sales area';
export const LOAD_SALES_AREA_SUCCESS = '[Point of delivery] Load sales area success';
export const LOAD_SALES_AREA_FAIL = '[Point of delivery] Load sales area fail';
export const POD_SET_AVAILABILITY = '[Point of delivery] set availability';
export const TOGGLE_SHOWING_POD_REQUESTS = '[Point of delivery] toggle showing pod requests';
export const NEW_POINT_OF_DELIVERY_CREATE = '[Point of delivery] new point of delivery create';
export const NEW_POINT_OF_DELIVERY_FAIL = '[Point of delivery] fail new point of delivery fail';
export const NEW_POINT_OF_DELIVERY_CREATED = '[Point of delivery] new point of delivery created';
export const RESET_NEW_POINT_OF_DELIVERY = '[Point of delivery] reset new point of delivery';
export const LOAD_NEW_ADDRESS_FAIL = '[Point of delivery] Load new address fail';
//
export const POINT_OF_DELIVERY_OPPORTUNITIES_CREATE = '[Point of delivery] Create';
export const POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS = '[Point of delivery] Create success';
export const PONT_OF_DELIVERY_OPPORTUNITIES_CREATE_FAIL = '[Point of delivery] Create fail';
export const PONT_OF_DELIVERY_DELETE_BY_ID = '[Point of delivery] DELETE BY ID';
export const PONT_OF_DELIVERY_DELETE_BY_ID_COMPLETE = '[Point of delivery] DELETE BY ID COMPLETE';

export const RESET_SNAPSHOT = '[Point of delivery] Reset SnapShot';
export const LOAD_ADDRESS_NAMES_SUCCESS = '[Point of delivery] Load address name success';
export const ADDRESS_NAMES_ADD_ENTITY = '[Point of delivery] Address names add entity';
export const LOAD_ADDRESS_NAME_FAIL = '[Point of delivery] Load address name fail';
export class PointOfDeliveryLoadInitialStateAction implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class PointOfDeliveryLoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: IShipmentLocation) {}
}

export class PointOfDeliveryLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: IShipmentLocationResponse) {}
}

export class PointOfDeliveryLoadFailAction implements Action {
  readonly type = LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class PointOfDeliveryRemoveSelectedAction implements Action {
  readonly type = REMOVE_SELECTED_POD;

  constructor(public payload: null) {}
}

export class PointOfDeliverySetAction implements Action {
  readonly type = POINT_OF_DELIVERY_SET;

  constructor(public payload: IShipmentLocation) {}
}

export class LoadPointOfDeliveryAddress {
  readonly type = LOAD_ADDRESS;

  constructor(public payload: IShipmentLocation) {}
}

export class LoadPointOfDeliveryAddressComplete {
  readonly type = LOAD_ADDRESS_SUCCESS;

  constructor(public payload: IAddressResponse | IRequestedAddressResponse) {}
}

export class LoadPointOfDeliveryAddressFail {
  readonly type = LOAD_ADDRESS_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}
export class LoadPointOfDeliveryNewAddressFail {
  readonly type = LOAD_NEW_ADDRESS_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class LoadPointOfDeliverySalesArea {
  readonly type = LOAD_SALES_AREA;

  constructor(public payload: IShipmentLocation) {}
}

export class LoadPointOfDeliverySalesAreaComplete {
  readonly type = LOAD_SALES_AREA_SUCCESS;

  constructor(public payload: IPointOfDeliverySalesArea[]) {}
}

export class LoadPointOfDeliverySalesAreaFail {
  readonly type = LOAD_SALES_AREA_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class PointOfDeliverySetAvailabilityAction {
  readonly type = POD_SET_AVAILABILITY;

  constructor(public payload: boolean) {}
}

export class PointOfDeliveryToggleShowingRequestsAction {
  readonly type = TOGGLE_SHOWING_POD_REQUESTS;

  constructor(public payload: boolean) {}
}

export class NewPointOfDeliveryCreateAction {
  readonly type = NEW_POINT_OF_DELIVERY_CREATE;

  constructor(public payload: PointOfDeliveryPayload) {}
}

export class NewPointOfDeliveryFailAction {
  readonly type = NEW_POINT_OF_DELIVERY_FAIL;

  constructor(public payload: any) {}
}

export class NewPointOfDeliveryCreatedAction {
  readonly type = NEW_POINT_OF_DELIVERY_CREATED;

  constructor(public payload: PointOfDeliveryRequest) {}
}

export class ResetNewPointOfDeliveryAction {
  readonly type = RESET_NEW_POINT_OF_DELIVERY;

  constructor() {}
}

export class PointOfDeliveryOpportunitiesCreateAction implements Action {
  readonly type = POINT_OF_DELIVERY_OPPORTUNITIES_CREATE;

  constructor(public payload: any) {}
}

export class PointOfDeliveryOpportunitiesCreateSuccessAction implements Action {
  readonly type = POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS;

  constructor(public payload: any) {}
}

export class PointOfDeliveryOpportunitiesCreateFailAction implements Action {
  readonly type = PONT_OF_DELIVERY_OPPORTUNITIES_CREATE_FAIL;

  constructor() {}
}

export class PointOfDeliveryDeleteById implements Action {
  readonly type = PONT_OF_DELIVERY_DELETE_BY_ID;
  constructor(public payload: any) {}
}
export class PointOfDeliveryDeleteByIdComplete implements Action {
  readonly type = PONT_OF_DELIVERY_DELETE_BY_ID_COMPLETE;
  constructor(public payload: any) {}
}

export class ResetSnapshot implements Action {
  readonly type = RESET_SNAPSHOT;
  constructor() {}
}

export class LoadPointOfDeliveryAddressNameComplete {
  readonly type = LOAD_ADDRESS_NAMES_SUCCESS;

  constructor(public payload: FormattedAddress[]) {}
}

export class PointOfDeliveryAddressNamesAddEntity {
  readonly type = ADDRESS_NAMES_ADD_ENTITY;

  constructor(public payload: FormattedAddress) {}
}

export class LoadPointOfDeliveryAddressNameFail {
  readonly type = LOAD_ADDRESS_NAME_FAIL;
  constructor(public payload: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type PointOfDeliveryActions =
  | PointOfDeliveryLoadInitialStateAction
  | PointOfDeliveryLoadAction
  | PointOfDeliveryLoadCompleteAction
  | PointOfDeliveryLoadFailAction
  | PointOfDeliveryRemoveSelectedAction
  | PointOfDeliverySetAction
  | LoadPointOfDeliveryAddress
  | LoadPointOfDeliveryAddressComplete
  | LoadPointOfDeliveryAddressFail
  | LoadPointOfDeliverySalesArea
  | LoadPointOfDeliverySalesAreaComplete
  | LoadPointOfDeliverySalesAreaFail
  | PointOfDeliverySetAvailabilityAction
  | PointOfDeliveryToggleShowingRequestsAction
  | NewPointOfDeliveryCreateAction
  | NewPointOfDeliveryFailAction
  | NewPointOfDeliveryCreatedAction
  | ResetNewPointOfDeliveryAction
  | LoadPointOfDeliveryNewAddressFail
  | PointOfDeliveryOpportunitiesCreateAction
  | PointOfDeliveryOpportunitiesCreateSuccessAction
  | PointOfDeliveryOpportunitiesCreateFailAction
  | PointOfDeliveryDeleteById
  | LoadPointOfDeliveryAddressNameComplete
  | PointOfDeliveryAddressNamesAddEntity
  | LoadPointOfDeliveryAddressNameFail;
